import React from 'react';
import '../../App.css';
import { connect } from 'react-redux';
import Category from './category';
import * as accessoriesAction from './../../actionSMB/accessoriesAction';
import FeaturedAccessories from './featuredAccessories';
import AccessoriesHeader from '../header/accessoriesHeader';
import Banner from './banner';
import { Utils } from '../../utilSMB/utils';
import { apiUrl } from '../../constantsSMB/apiUrl';
import api from '../../serviceSMB/apiService';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import Loader from './../../componentsSMB/loader';
import { getDTMInit } from './../../serviceSMB/dtmTag';
import { getVZDLInit } from './../../serviceSMB/vzdl';
import { updatePageLogs, checktime, catchJSException } from './../../serviceSMB/logService';
// import { errorAction } from './../../action/errorAction';
import * as checkoutAction from './../../actionSMB/checkoutAction';
import { Helmet } from 'react-helmet';

class Accessories extends React.PureComponent {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };

  getClientIp() {
    let clientIp = window.accip;
    if (clientIp !== undefined && clientIp !== '' && this.props.appState.clientIp === '') {
      accessoriesAction.updateClientIp(this.props.dispatch, clientIp);
      window.accip = '';
    } else {
      window.accip = '';
    }
  }

  getAcceptHeader() {
    let acceptHeader = window.acceptheader;
    if (acceptHeader !== undefined && acceptHeader !== '' && acceptHeader !== null && this.props.appState.acceptHeader === '') {
      accessoriesAction.updateAcceptHeader(this.props.dispatch, acceptHeader);
      window.acceptheader = '';
    } else {
      window.acceptheader = '';
    }
  }
  createVisitID() {
    try {
      // this.cookie_VisitId = window.localStorage.getItem("visit_id");
      this.cookie_VisitId = window.localStorage.getItem('visit_id_vtp');
      if (this.props.appState.visitId === '' || this.cookie_VisitId === null || this.cookie_VisitId === '') {
        const visitidUrl = apiUrl().createVisitId;
        return new Promise((resolve, reject) => {
          api(visitidUrl, 'GET', '')
            .then((response) => {
              if (Utils.isNotEmpty(response) && Utils.isNotEmpty(response.visit_id) && Utils.isNotEmpty(response.visitor_id)) {
                // window.localStorage.setItem('visit_id', response.visit_id);
                window.localStorage.setItem('visit_id_vtp', response.visit_id);
                window.localStorage.setItem('visitor_id', response.visitor_id);
                let expTime = response.expirationTime;
                if (!expTime && window.location.host.indexOf('localhost') !== -1) {
                  expTime = Date.now() + 86400000 - (new Date().getHours() * 60 + new Date().getMinutes()) * 60000;
                }
                // window.localStorage.setItem('expirationTime', expTime);
                window.localStorage.setItem('expirationTime_vtp', expTime);
                // window.sessionStorage.setItem('visit_id', response.visit_id);
                window.sessionStorage.setItem('visit_id_vtp', response.visit_id);
              }
              accessoriesAction.setCookie(this.props.cookies, response, this.props);
              this.processPageAfterVisitID();
              resolve(response);
            })
            .catch((error) => {
              reject('error-visitidcreation');
            });
        });
      } else console.log('createvisitid not invoked');
    } catch (ex) {
      catchJSException('Accessories', '', 'createVisitID', ex);
    }
  }
  processPageAfterVisitID = () => {
    try {
      updatePageLogs(this.props.appState, this.props.appState.visitId, false);
      checktime(this.callCheckTime('Mount'));
      // getDTMInit("checkAvaillqInit", { appInfo: this.props.appState, lqInfo: this.props.lqState });
    } catch (ex) {
      catchJSException('visitId_Error', this.props.appState.visitId, 'processPageAfterVisitID', ex);
    }
  };
  callCheckTime = (pagestate) => {
    return {
      page: 'homepage',
      mount: pagestate === 'Mount' && Date.now(),
      unmount: pagestate === 'WillMount' && Date.now(),
      pageURL: window.location.href,
      visitid: this.props.appState.visitId || 'visit_id_not_created',
      noSSNCheck: false,
    };
  };
  loadScript = (url) => {
    try {
      let script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = url;
      document.body.appendChild(script);
    } catch (ex) {
      catchJSException('Accessories', '', 'loadScript', ex);
    }
  };

  injectDDScript = () => {
    try {
      document.body.setAttribute('class', 'kaxsdc');
      document.body.setAttribute('data-event', 'load');
      let safetechMerchantId = '300637';
      let sessionId = this.props.appState && this.props.appState.visitId;
      let url = 'https://tst.kaptcha.com/'; /**for non-prod*/
      let host = window.location.host;
      if (host === 'www.verizon.com') {
        url = 'https://ssl.kaptcha.com/';
      }
      let scriptUrl = url + 'collect/sdk?m=' + safetechMerchantId + '&s=' + sessionId;
      this.loadScript(scriptUrl);
      let script = document.createElement('script');
      script.type = 'text/javascript';
      script.innerText = `setTimeout(function () {if(typeof ka != 'undefined'){var client=new ka.ClientSDK();client.autoLoadEvents ();}},3000)`;
      document.body.appendChild(script);
    } catch (ex) {
      catchJSException('Accessories', '', 'injectDDScript', ex);
    }
  };
  componentWillMount() {
    if (window.smbRefreshGnav) {
      window.smbRefreshGnav('');
    }
    checktime(this.callCheckTime('WillMount'));
    if (Utils.isNotNull(this.props.orderSubmitState) && this.props.orderSubmitState.orderPlaced === 'Y') {
      Utils.clearRedux('all');
      // window.localStorage.setItem('visit_id', "");
      window.localStorage.setItem('visit_id_vtp', '');
      window.localStorage.setItem('visitor_id', '');
    }
    this.getClientIp();
    this.getAcceptHeader();
    let validatePromise = this.createVisitID();
    Promise.all([validatePromise]).then((response) => {
      const { cookies } = this.props;
      // let validatePromise
      let userInfo = cookies.get('userinfo');
      if (
        userInfo !== undefined &&
        userInfo !== '' &&
        userInfo !== null &&
        !this.props.categoriesState.isProfileCall &&
        !this.props.categoriesState.isGuestFlow
      ) {
        // validatePromise=checkoutAction.getProfileInfo(this.props.dispatch,this.props.appState.visitId);
        // accessoriesAction.updateSigninApplied(true,this.props.dispatch)
        // accessoriesAction.updateFlowType("AF",this.props.dispatch)
      }
      if (typeof ka == 'undefined') {
        this.injectDDScript(); //Script for Safetech Device Data Collector
      }
      accessoriesAction.updateLBO(this.props.dispatch);
      accessoriesAction.getbannerFromAPI(this.props.dispatch);
      accessoriesAction.getCategoriesFromAPI(this.props.dispatch);
      accessoriesAction.getHeaderContent(this.props.dispatch, this.props.appState.visitId);
      accessoriesAction.getStandardErrorsFromAPI(this.props.dispatch, this.props.appState.visitId);
      getVZDLInit(this.props.appState.visitId, 'home', '', '', '', '', 'Accessories');
      //  Promise.all([validatePromise])
      //  .then(value=>{
      let request = {
        signedIn: this.props.categoriesState.isValidUser,
      };
      accessoriesAction.getfeaturedAccessoriesFromAPI(this.props.dispatch, this.props.appState.visitId, JSON.stringify(request));
      // })
      // setTimeout(() => {
      //     let request={
      //         "signedIn": this.props.categoriesState.isValidUser
      //      }
      //     //  accessoriesAction.getStandardErrorsFromAPI(this.props.dispatch,this.props.appState.visitId);
      //     // accessoriesAction.getCategoriesFromAPI(this.props.dispatch);
      //       accessoriesAction.getfeaturedAccessoriesFromAPI(this.props.dispatch,this.props.appState.visitId,JSON.stringify(request));

      //     // accessoriesAction.getbannerFromAPI(this.props.dispatch);
      //     // accessoriesAction.getShoppingCartContent(this.props.dispatch,this.props.appState.visitId);
      //     // accessoriesAction.getHeaderContent(this.props.dispatch,this.props.appState.visitId)
      //     //  accessoriesAction.getShoppingCartContent(this.props.dispatch,this.props.appState.visitId);
      // }, 3000);
      return response;
    });

    // accessoriesAction.getCategoriesFromJSON(this.props.dispatch);

    var vtpFlowType = 'FIOS';
    var aimsFlow = 'LearnServiceVTP';
    var aimsChatCreditFlow = 1;
    if (vtpFlowType === 'FIOS') {
      aimsChatCreditFlow = 1;
    }
    try {
      if (typeof aimsChatCreditFlow !== 'undefined') {
        window.setCustomerInfo('OTHER', aimsChatCreditFlow);
        window.reInit();
      }
    } catch (ex) {
      catchJSException('loopQual', this.props.appState.visitId, 'setBannerType', ex);
    }
    if (typeof setExtraCustomerInfo !== 'undefined') {
      window.setExtraCustomerInfo('SOURCE_PAGE', 'AccessoriesHome');
      window.setExtraCustomerInfo('other', aimsFlow);
    }
  }
  componentDidMount() {
    let transactionData = {
      visitId: this.props.appState.visitId,
    };
    getDTMInit('accessoriesHome', '', '', '', '', '', '', '', transactionData);
  }
  render() {
    let metaInfo;
    metaInfo = (
      <div>
        <Helmet>
          <meta
            name="keywords"
            content="fios, fios tv, router, wifi, cables, connectors, networking, network, fios accessories,smart home,fun,fitness"
          />
          <meta
            name="description"
            content="Buy Verizon accessories to get the most out of your Verizon experience. Shop for your Fios TV remote control, phone charger, router &amp; Wifi"
          />
        </Helmet>
      </div>
    );

    let featuredAccessoriesExp;
    let bannerExp;

    // if (this.props.categoriesState && this.props.categoriesState.featuredAccessoriesExp) {
    featuredAccessoriesExp = this.props.categoriesState.featuredAccessoriesExp;
    bannerExp = this.props.categoriesState.bannerExp;
    // }
    let category = <Category appState={this.props.appState} categoriesValue={this.props.categoriesState} props={this.props} />;
    let featuredAccessories = (
      <FeaturedAccessories
        appState={this.props.appState}
        featuredAccessoriesValue={featuredAccessoriesExp}
        categoriesState={this.props.categoriesState}
        props={this.props}
      />
    );
    let accessoriesHeader = <AccessoriesHeader accessoriesHeaderValue={this.props.categoriesState} props={this.props}></AccessoriesHeader>;
    let banner = <Banner bannerValue={bannerExp} props={this.props} />;
    return (
      <div className="App bg-white ">
        {metaInfo}
        <Loader />
        {accessoriesHeader}
        {banner}
        <div className="store-front-container">{category}</div>
        <div className="featured-accessories ">{featuredAccessories}</div>
        <div className="margin-bottom-large clear">&nbsp;</div>
        <div className="margin-bottom-large clear">&nbsp;</div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    appState: state.appSMB,
    categoriesState: state.categoriesSMB,
    orderSubmitState: state.orderSubmitSMB,
  };
};

// export default (connect(
//     mapStateToProps
// )(Accessories));
//export default Accessories;

export default withCookies(connect(mapStateToProps)(Accessories));
